import moneyDisplay from "../../../../components/moneyDisplay/moneyDisplay";
import { connect } from "react-redux";
import { asPercentage } from "../../../../utils/formatters";
export default connect(state => ({
  value: asPercentage(state.firstRiders.firstTimeRiders.closing.prevClosingPercentMTD),
  currency: "%",
  currencyLocation: "end",
  url: state.firstRiders.firstTimeRiders.closing.prevClosingMTDLink,
  disableAnimation: state.firstRiders.currentUser.qa
}))(moneyDisplay);
